import React from 'react'
import { USER_DETAIL } from '../urls'
import { usePutRequest } from '../hooks/request'
import UserForm from './UserForm'
import { useMessage } from '../hooks/message'

export default function UserUpdate({ hideModal, item, users }) {
    const [showMessage] = useMessage()
    const userUpdate = usePutRequest({ url: USER_DETAIL.replace('{id}', item.id) })

    async function onSubmit(data) {
        const { success, error } = await userUpdate.request({ data })

        if (success) {
            users.request()
            showMessage('Пользователь успешно обновлен', 'is-success')
            hideModal()
        }
        if (error) {
            showMessage(error?.data?.detail || 'Ошибка при обновлении пользователя', 'is-danger')
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered"><b>Изменить пользователя</b></h1>

            <UserForm
                loading={userUpdate.loading}
                onCancel={hideModal}
                initialValues={{
                    ...item,
                }}
                onSubmit={onSubmit}
            />
        </div>
    )
}
